module.exports = __webpack_public_path__ + "static/media/logo-icon-white.419bb0bf.png";